module.exports = __webpack_public_path__ + "static/civil-aviation-logo-83009f8285e426bce4ddde950df5d7f9.jpg";